<template>
  <div class="express-scan-container">
    <!-- 顶部导航栏 -->
    <div class="header">
      <span class="title">快递单号</span>
      <vxe-input
        v-model="expressNumber"
        placeholder="快递单号"
        class="express-input"
      />
    </div>

    <!-- 主内容区 -->
    <div class="main-content">
      <!-- 左侧统计区 -->
      <div class="statistics-panel">
        <div class="summary-title">
          <span>今日扫描汇总</span>
          <a-icon type="sync" class="refresh-icon" />
        </div>

        <!-- 总计卡片 -->
        <div class="summary-cards">
          <div class="summary-card primary-card">
            <div class="card-title">本次扫描</div>
            <div class="card-value">0</div>
          </div>
          <div class="summary-card secondary-card">
            <div class="card-title">今日总计</div>
            <div class="card-value">0</div>
          </div>
        </div>

        <!-- 快递公司统计网格 -->
        <div class="company-grid">
          <div class="company-card" v-for="company in companies" :key="company.id">
            <div class="company-name">{{ company.name }}</div>
            <div class="company-count">{{ company.count }}</div>
          </div>
        </div>
      </div>

      <!-- 右侧扫描记录区 -->
      <div class="scan-records-panel">
        <div class="records-title">扫描记录</div>
        <div class="records-content">
          <!-- 这里可以根据需要添加扫描记录列表 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expressNumber: '',
      companies: [
        { id: 1, name: '申通', count: 0 },
        { id: 2, name: '圆通', count: 0 },
        { id: 3, name: '中通', count: 0 },
        { id: 4, name: '汇通', count: 0 },
        { id: 5, name: '韵达', count: 0 },
        { id: 6, name: '京东', count: 0 },
        { id: 7, name: '天天', count: 0 },
        { id: 8, name: '顺丰', count: 0 },
        { id: 9, name: '邮政', count: 0 },
        { id: 10, name: '宅急送', count: 0 },
        { id: 11, name: 'EMS', count: 0 },
        { id: 12, name: '德邦', count: 0 },
        { id: 13, name: '跨越', count: 0 },
        { id: 14, name: '全峰', count: 0 },
        { id: 15, name: '极兔', count: 0 },
        { id: 16, name: '安能', count: 0 },
        { id: 17, name: '丹鸟', count: 0 },
        { id: 18, name: '邮政电商标快', count: 0 },
        { id: 19, name: '其它', count: 0 }
      ]
    };
  }
};
</script>

<style scoped>
.express-scan-container {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  overflow: hidden;
}

/* 顶部样式 */
.header {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #e8e8e8;
}

.title {
  font-size: 16px;
  margin-right: 12px;
  color: #333;
}

.express-input {
  flex: 1;
  max-width: 300px;
}

.connection-status {
  display: flex;
  align-items: center;
  color: #1890ff;
  font-size: 14px;
}

.connection-status span {
  margin-left: 4px;
}

/* 主内容区样式 */
.main-content {
  display: flex;
  height: calc(100vh - 70px);
}

/* 左侧统计面板 */
.statistics-panel {
  flex: 3;
  padding: 16px;
  border-right: 1px solid #e8e8e8;
  overflow-y: auto;
}

.summary-title {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  color: #333;
  font-size: 16px;
}

.refresh-icon {
  margin-left: 8px;
  cursor: pointer;
  color: #999;
}

/* 汇总卡片样式 */
.summary-cards {
  display: flex;
  margin-bottom: 24px;
  gap: 16px;
}

.summary-card {
  flex: 1;
  padding: 16px;
  border-radius: 4px;
  text-align: center;
  min-width: 120px;
}

.primary-card {
  background-color: #e6f7ff;
}

.secondary-card {
  background-color: #fff7e6;
}

.card-title {
  font-size: 14px;
  margin-bottom: 8px;
  color: #666;
}

.card-value {
  font-size: 24px;
  font-weight: bold;
}

.primary-card .card-value {
  color: #1890ff;
}

.secondary-card .card-value {
  color: #fa8c16;
}

/* 公司网格样式 */
.company-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.company-card {
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 16px 8px;
  text-align: center;
}

.company-name {
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.company-count {
  font-size: 20px;
  font-weight: bold;
  color: #333;
}

/* 右侧扫描记录面板 */
.scan-records-panel {
  flex: 1;
  padding: 16px;
  background-color: #fafafa;
}

.records-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 16px;
}

.records-content {
  height: calc(100% - 32px);
  background-color: #fff;
  border-radius: 4px;
  overflow-y: auto;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .company-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 992px) {
  .company-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .main-content {
    flex-direction: column;
  }

  .statistics-panel {
    border-right: none;
    border-bottom: 1px solid #e8e8e8;
    height: auto;
    max-height: 50%;
  }

  .scan-records-panel {
    height: 50%;
  }
}

@media (max-width: 576px) {
  .company-grid {
    grid-template-columns: 1fr;
  }

  .summary-cards {
    flex-direction: column;
  }
}
</style>
